import { render, staticRenderFns } from "./RefundConfigForm.vue?vue&type=template&id=45c2f7f6&scoped=true&"
import script from "./RefundConfigForm.vue?vue&type=script&lang=ts&"
export * from "./RefundConfigForm.vue?vue&type=script&lang=ts&"
import style0 from "./RefundConfigForm.vue?vue&type=style&index=0&id=45c2f7f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2f7f6",
  null
  
)

export default component.exports